import React from 'react'
import { Link } from 'react-router-dom'

const breadcrumbInvoice = () => {
  return (
    <div className="container">
      <nav className="breadcrumb">
        <Link to="/">Home</Link> <i className="fas fa-angle-right"></i>
        <Link to="/me/orders">My Orders</Link>
        <i className="fas fa-angle-right"></i> Invoice Order
      </nav>
    </div>
  );
};

export default breadcrumbInvoice;
